export const BORDER = "border";
export const SAME_CURRENCY = "same-currency";
export const CLOSE_TIMEZONE = "close-timezone";
export const ANOTHER_CONTINET = "another-continent";
